import type {ProLayoutProps} from '@ant-design/pro-components';

const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#5b8cff',
  layout: 'mix',
  contentWidth: 'Fluid',
  siderWidth: 208,
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'ChiForm Project Admin',
  pwa: true,
  iconfontUrl: '',
  logo: '/logo_v2.svg',
};

export default Settings;
